import space from '../namespace';
import defaultState, { IState } from '../state';
import actionTypes, { IAction, ActionTypeValues } from '../actionTypes';

const reducer = (
  state: IState,
  action: IAction<
    Partial<IState[space.square]> & {
      namespace?: `${space}`;
      resetKeys?: string[];
    }
  >,
): IState => {
  const { type, namespace = space.square, payload } = action;

  switch (type) {
    case actionTypes[namespace][ActionTypeValues.UPDATE_SQUARE_CHANNEL_LIST]: {
      const _state = state[namespace];
      return {
        ...state,
        [namespace]: {
          ..._state,
          channelList: payload
        }
      }
    }
    case actionTypes[namespace][ActionTypeValues.UPDATE_SQUARE_ARTICAL_LIST]: {
      const _state = state[namespace as space.square];
      return {
        ...state,
        [namespace]: {
          ..._state,
          articalList: { ...(_state?.articalList || {}), ...payload },
        }
      }
    }
    case actionTypes[namespace][ActionTypeValues.UPDATE_SQUARE_CHANNEL_ACTIVE_KEYS]: {
      const _state = state[namespace];
      return {
        ...state,
        [namespace]: {
          ..._state,
          channelActiveKeys: payload,
        }
      }
    }
    case actionTypes[namespace][ActionTypeValues.UPDATE_SQUARE_CHANNEL_SORT_KEY_MAP]: {
      const _state = state[namespace as space.square];
      return {
        ...state,
        [namespace]: {
          ..._state,
          channelSortKeyMap: { ...(_state?.channelSortKeyMap || {}), ...payload },
        }
      }
    }
    default:
      return state;
  }
};

export default reducer;
